import { backendApi } from "@/services/api";
import { ServiceObject } from "./service-object";

const serviceObjectsApi = backendApi.injectEndpoints({
  endpoints: (build) => ({
    listServiceObjects: build.query<List, ListRequest>({
      query: (request) => ({
        url: `/customers/service-objects`,
        method: "GET",
        params: {
          request: btoa(JSON.stringify(request)),
        },
      }),
      providesTags: ["ServiceObject"],
    }),
    getServiceObject: build.query<ServiceObject, GetRequest>({
      query: (request) => ({
        url: `/customers/service-objects/${request.id}`,
        method: "GET",
      }),
      providesTags: ["ServiceObject"],
    }),
  }),
});

export const { useListServiceObjectsQuery, useGetServiceObjectQuery } =
  serviceObjectsApi;

export interface GetRequest {
  id: string;
}

export interface ListRequest {
  limit: number;
  offset: number;
}

export interface List {
  count: number;
  items: ServiceObject[];
}
